// The names of a texture's maps (docs/BLIP_MODELS_DESIGN.md, "Textures"):
// make_picture (models.js) saves them beside its colour map, and the World
// Editor's paint (world.js, editor_requests.bb) finds them there:
// cobbles.png has cobbles-normal.png, cobbles-height.png and
// cobbles-metallicroughness.png, a name the Material Editor's import reads
// as a packed metallicRoughness map.
export const MAP_SUFFIXES = { normal: "-normal", height: "-height", metallicRoughness: "-metallicroughness" };

// Where a texture's map of a kind is, beside its colour map.
export function mapPath(path, kind) {
  return path.replace(/(\.[a-z0-9]{1,5})?$/i, `${MAP_SUFFIXES[kind]}.png`);
}
